import { render, staticRenderFns } from "./visitorDetail.vue?vue&type=template&id=7f6b040b&scoped=true&"
import script from "./visitorDetail.vue?vue&type=script&lang=ts&"
export * from "./visitorDetail.vue?vue&type=script&lang=ts&"
import style0 from "./visitorDetail.vue?vue&type=style&index=0&id=7f6b040b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b040b",
  null
  
)

export default component.exports